import React from 'react';
import PropTypes from 'prop-types';

// FSSAI vegetarian mark (India). Regulated colours when active; greyed when inactive (e.g. unselected filter).
const FssaiVegetarianIcon = ({ className, width, height, active }) => {
  const colour = active ? '#00a651' : '#bbb';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 200 200"
    >
      <rect x="25" y="25" width="150" height="150" fill="none" stroke={colour} strokeWidth="5" />
      <circle cx="100" cy="100" r="50" fill={colour} />
    </svg>
  );
};

FssaiVegetarianIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  active: PropTypes.bool,
};

FssaiVegetarianIcon.defaultProps = {
  height: '100%',
  width: '100%',
  active: true,
};

export default FssaiVegetarianIcon;
